import {
    Form,
    Button,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap'
import { NextPage } from 'next'
import React from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import moment from 'moment'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import Link from 'next/link'
import { routes } from '~/router'

const CommentInformation: NextPage<AppCommonProps> = ({
    item, profile, setIsEdit, isEdit, setHeight, height, videoUserID, commentItemRef, handleHideComment, handleDeleteComment,
    handleEdit, handleOnChange, isLoadingComment, onEmojiClick, showPicker, setShowPicker
}: any) => {
    return (
        <>
            <div className="d-flex">
                {item.sso_uid ? <><span>{item.nick_name
                    ? <>{item.nick_name}</>
                    : (item?.userSSO.nick_name ? <>{item?.userSSO.nick_name}</>
                        : <>{item?.email.substring(0, 1) + '**********' + item?.email.substring(item?.email.length - 1, item?.email.length)}</>)}さん</span></> : <>
                    <Link href={{
                        pathname: routes.user.username.href,
                        query: { id: item.user_id }
                    }}>
                        <a target="_blank" className="ac-text-blue d-block">
                            <span>{item.nick_name
                                ? <>{item.nick_name}</>
                                : <>{item?.email.substring(0, 1) + '**********' + item?.email.substring(item?.email.length - 1, item?.email.length)}</>}さん</span>
                        </a>
                    </Link>
                </>}
                <span className="ml-3">{moment(item.created_at).format("LL")}</span>
                <div className="ml-3 comment-options">
                    {profile.id === item.user_id && <OverlayTrigger
                        // key={'top'}
                        placement={'top'}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                                編集
                            </Tooltip>
                        }
                    >
                        <span className="text-949494">
                            <i className="fa fa-pencil" aria-hidden="true" onClick={() => {
                                setIsEdit(!isEdit)
                                setHeight(`${commentItemRef.current?.clientHeight + 19}px`)
                            }}></i>
                        </span>
                    </OverlayTrigger>}
                    {(videoUserID === profile.id) && <OverlayTrigger
                        // key={'top'}
                        placement={'top'}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                                非表示
                            </Tooltip>
                        }
                    >
                        <span className="text-949494">
                            <i className="fa fa-eye-slash ml-2" aria-hidden="true" onClick={() => { handleHideComment() }}></i>
                        </span>
                    </OverlayTrigger>}
                    {(profile.id === item.user_id || videoUserID === profile.id) && <span className="ac-text-danger">
                        <OverlayTrigger
                            // key={'top'}
                            placement={'top'}
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    消去
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-trash ml-2" aria-hidden="true" onClick={() => { handleDeleteComment() }}></i>
                        </OverlayTrigger>
                    </span>}
                </div>
            </div>
            {!isEdit && <div className="mt-2" ref={commentItemRef}>
                {item.content.split('\n').map((line: any, i: any) => (
                    <>
                        {line}
                        <br />
                    </>
                ))}
            </div>}
            {
                isEdit && <div className="picker-container">
                    <Form.Control as="textarea" className="text-area-comment" defaultValue={item.content}
                        onChange={(e) => { handleOnChange(e) }} style={{ height }} />
                    <div className="emoji-container">
                        <img
                            className="emoji-icon"
                            alt="true"
                            src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                            onClick={() => setShowPicker((val: any) => !val)}
                        />
                        <Button variant="primary" type="button" className="ac-btn-sm ac-btn-video rounded-left-0 ml-4 button-comment" disabled={isLoadingComment}
                            onClick={handleEdit}>
                            送信
                        </Button>
                    </div>
                    {showPicker && (
                        <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
                    )}
                </div>
            }</>
    )
}


export default withI18n(CommentInformation)
